import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UserViewModal = ({ isOpen, onClose, user, language, onEdit, onDelete }) => {
  if (!isOpen || !user) return null;

  const labels = {
    title: { en: 'User Details', ar: 'تفاصيل المستخدم' },
    name: { en: 'Name', ar: 'الاسم' },
    phoneNumber: { en: 'Phone Number', ar: 'رقم الهاتف' },
    userType: { en: 'User Type', ar: 'نوع المستخدم' },
    edit: { en: 'Edit', ar: 'تعديل' },
    delete: { en: 'Delete', ar: 'حذف' },
    close: { en: 'Close', ar: 'إغلاق' }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow-elevation-4 border border-border w-full max-w-md">
        <div className="border-b border-border px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-foreground">
            {labels?.title?.[language]}
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-smooth"
            aria-label="Close"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.name?.[language]}</label>
            <p className="text-base font-medium text-foreground mt-1">{user?.name}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.phoneNumber?.[language]}</label>
            <p className="text-base font-medium text-foreground mt-1">{user?.phoneNumber}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.userType?.[language]}</label>
            <p className="text-base font-medium text-foreground mt-1">
              <span className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-primary/10 text-primary">
                {user?.userType}
              </span>
            </p>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              variant="outline"
              fullWidth
              onClick={onEdit}
              iconName="Edit2"
            >
              {labels?.edit?.[language]}
            </Button>
            <Button
              variant="destructive"
              fullWidth
              onClick={onDelete}
              iconName="Trash2"
            >
              {labels?.delete?.[language]}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserViewModal;